import { storage } from '@itau-loans-www/utils'

import common from '../common/fgts'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export default (key) => {
  const partner = storage.session.getItem(`${storageName}_leadData`)?.partner

  const payloadsMap = {
    'btn:consultar': {
      custom_path: '/fgts/saque-aniversario/home',
      detail: 'btn:consultar',
      ...common(partner)
    },
    'btn:contratar-via-whatsapp': {
      custom_path: '/fgts/saque-aniversario/home',
      detail: 'btn:contratar-via-whatsapp',
      ...common(partner)
    },
    'btn:conhecer-oferta': {
      custom_path: '/fgts/saque-aniversario/home',
      detail: 'btn:conhecer-oferta',
      ...common(partner)
    },
    'btn:seguir-calculadora-simplificada': {
      custom_path: '/fgts/saque-aniversario/home',
      detail: 'btn:seguir-calculadora-simplificada',
      ...common(partner)
    },
    'btn:whatsapp-flutuante': {
      custom_path: '/fgts/saque-aniversario/home',
      detail: 'btn:whatsapp-flutuante',
      ...common(partner)
    },
    'btn:finalizar-no-app-itau': {
      custom_path: '/fgts/saque-aniversario/oferta/correntista',
      detail: 'btn:finalizar-no-app-itau',
      ...common(partner)
    },
    'btn:editar-oferta': {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista',
      detail: 'btn:editar-oferta',
      ...common(partner)
    },
    'btn:abrir-app-itau': {
      custom_path:
        '/fgts/saque-aniversario/formalizacao/correntista/redirect-app',
      detail: 'btn:abrir-app-itau',
      ...common(partner)
    },
    'btn:finalizar-pelo-whatsapp-dados-adicionais': {
      custom_path:
        '/fgts/saque-aniversario/oferta/nao-correntista/dados-adicionais',
      detail: 'btn:finalizar-pelo-whatsapp',
      ...common(partner)
    },
    'btn:finalizar-pelo-whatsapp-documento': {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/documento',
      detail: 'btn:finalizar-pelo-whatsapp',
      ...common(partner)
    },
    'btn:finalizar-pelo-whatsapp-endereco': {
      custom_path: '/fgts/saque-aniversario/oferta/nao-correntista/endereco',
      detail: 'btn:finalizar-pelo-whatsapp',
      ...common(partner)
    },
    'btn:finalizar-pelo-whatsapp-dados-bancarios': {
      custom_path:
        '/fgts/saque-aniversario/oferta/nao-correntista/dados-bancarios',
      detail: 'btn:finalizar-pelo-whatsapp',
      ...common(partner)
    },
    'btn:acessar-app': {
      custom_path: '/fgts/saque-aniversario/elegivel/autorizacao-pendente',
      detail: 'btn:acessar-app',
      ...common(partner)
    },
    'btn:nova-simulacao': {
      custom_path: '/fgts/saque-aniversario/proposta-pendente/erro',
      detail: 'btn:nova-simulacao',
      ...common(partner)
    }
  }

  return payloadsMap[key] ?? {}
}
